'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// blacklist for removing style props with tag-hoc
// related: https://github.com/styled-components/styled-components/issues/439

exports.default = ['width', 'w', 'maxWidth', 'fontSize', 'f', 'color', 'bg', 'm', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'active', 'ratio', 'bold', 'caps', 'size', 'left', 'center', 'right', 'justify', 'top', 'bottom', 'z', 'backgroundImage', 'borderWidth', 'size', 'position', 'index', 'direction', 'text'];